import type { LabelHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-[12px] font-medium text-fg', className)} {...props} />;
}
